export function waitForAppReady(store) {
  return new Promise((resolve) => {
    if (store.state.isReady) {
      resolve();
    } else {
      const unwatch = store.watch(
        (state) => state.isReady,
        (ready) => {
          if (ready) {
            unwatch();
            resolve();
          }
        }
      );
    }
  });
}
